import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-8 py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/22f508420db1f1c1ae1793f5f3dbe676.jpg"
          alt="BillPlay Culture"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black"></div>
      </div>

      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-20 px-8 py-6">
        <div className="max-w-[1600px] mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
            <img
              src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/5b9bd2cbb4f3f977486d4a8e60efd124.jpeg"
              alt="BillPlay Apparel"
              className="h-[60px] w-auto object-contain"
            />
          </Link>
          <Link 
            to="/shop" 
            className="text-sm font-bold text-white hover:underline whitespace-nowrap"
          >
            SHOP NOW
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="relative z-10 max-w-[1200px] mx-auto text-center">
        <div className="inline-flex items-center gap-2 border border-white/30 rounded-full px-6 py-2 mb-8">
          <span className="text-xs font-bold text-white tracking-wide">EST. 2017 • KALAMAZOO, MI</span>
        </div>

        <h1 className="text-7xl md:text-8xl lg:text-9xl font-black text-white leading-[0.9] tracking-tight mb-8">
          CULTURE<br />
          OVER<br />
          <span className="bg-gradient-to-r from-white via-gray-200 to-white bg-clip-text text-transparent">EVERYTHING</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-12">
          BillPlay Apparel is more than fashion. It's a movement rooted in community, built on authenticity, and designed for people who refuse to blend in.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link 
            to="/shop" 
            className="bg-white text-black px-10 py-4 rounded-lg font-black text-sm hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            EXPLORE THE BRAND
          </Link>
          <a 
            href="#contact" 
            className="border border-white text-white px-10 py-4 rounded-lg font-black text-sm hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap"
          >
            GET IN TOUCH
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}